const updatePromos = (json, code) => {
  const promoNotificationWrapper = document.querySelector(
    '.promo-notification-wrapper',
  );
  const promocodeInput = document.querySelector(
    '.promocode-input-wrapper input',
  );
  const promocodeInputWrapper = document.querySelector('.promocode-input');
  const promocodeInputPlaceholder = document.querySelector('.placeholder');
  const promocodeSubmitBtn = document.querySelector('.promocode-submit');
  const promoErrorText = document.querySelector('.promo-error');
  const removePromoBtn = document.querySelector('.remove-promo');
  const promoFormDescription = document.querySelector('.promo-description');
  const promoSubmitWrapper = document.querySelector(
    '.cart-promocode-form .submit-wrapper',
  );
  const promoCancelWithProductsBtn = document.querySelector(
    '.cart-promocode-form .cancel-promo-with-products',
  );
  const promotionProducts = document.querySelector(
    '.cart-promocode-form .promotion-products',
  );
  const promotionProductsList = document.querySelector(
    '.cart-promocode-form .promotion-products-list',
  );
  const promoApplyWithProducts = document.querySelector(
    '.cart-promocode-form .apply-promo-with-products',
  );

  if (promoSubmitWrapper && promoSubmitWrapper.classList.contains('hidden')) {
    promoSubmitWrapper.classList.remove('hidden');
  }

  if (
    promoCancelWithProductsBtn &&
    promoCancelWithProductsBtn.classList.contains('visible')
  ) {
    promoCancelWithProductsBtn.classList.remove('visible');
  }

  if (promotionProducts) {
    promotionProducts.classList.remove('visible');
  }

  if (promotionProductsList) {
    promotionProductsList.textContent = '';
  }

  if (promocodeInputWrapper) {
    promocodeInputWrapper.classList.remove('error');
  }

  if (promoFormDescription) {
    promoFormDescription.classList.remove('visible');
    promoFormDescription.textContent = '';
  }

  if (promoErrorText) {
    promoErrorText.classList.remove('visible');
    promoErrorText.textContent = '';
  }

  if (promoApplyWithProducts) {
    promoApplyWithProducts.textContent = 'Далее';
    promoApplyWithProducts.removeAttribute('disabled');
  }

  if (promoNotificationWrapper) {
    promoNotificationWrapper.textContent = '';

    const filteredPromos = [];

    json.forEach((item) => {
      if (item.type === 'promocode') {
        if (item.hidden) {
          filteredPromos.push(item);
        }
      } else {
        filteredPromos.push(item);
      }
    });

    let currentPromocode;

    if (code) {
      currentPromocode = json.find((item) => item.data.code === code);
    } else {
      currentPromocode = json.find(
        (item) => item.type === 'promocode' && !item.hidden,
      );
    }

    if (
      currentPromocode &&
      !currentPromocode.active &&
      !currentPromocode.name
    ) {
      if (promocodeInput) {
        promocodeInput.value = currentPromocode.data.code;
      }

      if (promocodeInputWrapper) {
        promocodeInputWrapper.classList.add('error');
      }

      if (promocodeInputPlaceholder) {
        promocodeInputPlaceholder.textContent = 'Неверный промокод';
      }

      if (promocodeSubmitBtn) {
        promocodeSubmitBtn.removeAttribute('disabled');
        promocodeSubmitBtn.value = 'Применить';
        promocodeSubmitBtn.classList.add('hidden');
      }

      if (promoErrorText) {
        promoErrorText.classList.add('visible');
      }

      if (removePromoBtn) {
        removePromoBtn.classList.add('visible');
        removePromoBtn.dataset.code = code;
      }
    } else if (currentPromocode && !currentPromocode.hidden) {
      if (promocodeInput) {
        promocodeInput.value = currentPromocode.data.code;
      }

      if (promocodeInputWrapper) {
        if (currentPromocode.active) {
          promocodeInputWrapper.classList.add('valid');
          promocodeInputWrapper.classList.remove('error');
        } else {
          promocodeInputWrapper.classList.remove('valid');
          promocodeInputWrapper.classList.add('error');
        }
      }

      if (promocodeInputPlaceholder) {
        if (currentPromocode.active) {
          promocodeInputPlaceholder.textContent = 'Промокод активен';
        } else {
          promocodeInputPlaceholder.textContent = 'Прокод не активен';
        }
      }

      if (promocodeSubmitBtn) {
        promocodeSubmitBtn.removeAttribute('disabled');
        promocodeSubmitBtn.value = 'Применить';
        promocodeSubmitBtn.classList.add('hidden');
      }

      if (promoErrorText) {
        promoErrorText.classList.add('visible');

        if (currentPromocode.active) {
          promoErrorText.textContent = 'Условия выполнены';
          promoErrorText.classList.add('green-color');
        } else {
          promoErrorText.textContent = 'Условия не выполнены';
          promoErrorText.classList.remove('green-color');
        }
      }

      if (promoFormDescription) {
        promoFormDescription.classList.add('visible');

        let promoDescriptionText;

        if (currentPromocode.description) {
          promoDescriptionText = currentPromocode.description;
        } else {
          promoDescriptionText = currentPromocode.name;
        }

        if (currentPromocode.active) {
          promoFormDescription.textContent = `Вы выполнили условия акции: ${promoDescriptionText}`;
        } else {
          promoFormDescription.textContent = `Вы не выполнили условия акции: ${promoDescriptionText}`;
        }
      }

      if (removePromoBtn) {
        removePromoBtn.classList.add('visible');
        removePromoBtn.dataset.code = currentPromocode.data.code;
      }
    } else {
      if (promocodeInput) {
        promocodeInput.value = '';
      }

      if (promocodeInputWrapper) {
        promocodeInputWrapper.classList.remove('error', 'valid');
      }

      if (promocodeInputPlaceholder) {
        promocodeInputPlaceholder.textContent = 'Введите промокод';
      }

      if (promocodeSubmitBtn) {
        promocodeSubmitBtn.removeAttribute('disabled');
        promocodeSubmitBtn.value = 'Применить';
        promocodeSubmitBtn.classList.remove('hidden');
      }

      if (promoErrorText) {
        promoErrorText.classList.remove('visible', 'green-color');
      }

      if (removePromoBtn) {
        removePromoBtn.classList.remove('visible');
        removePromoBtn.dataset.code = '';
      }
    }

    const items = filteredPromos.map((promo) => {
      let promoBaseText;
      let promoBaseDescription;
      let promoNotificationContent;
      let promoValidString;

      if (promo.active) {
        promoNotificationContent =
          '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="valid-icon icon"><path d="M17.0711 2.92891C15.1823 1.0402 12.6711 0 10 0C7.32887 0 4.81762 1.0402 2.92891 2.92891C1.04016 4.81766 0 7.32891 0 10C0 12.6711 1.04016 15.1823 2.92891 17.0711C4.81766 18.9598 7.32887 20 10 20C12.6711 20 15.1823 18.9598 17.0711 17.0711C18.9598 15.1823 20 12.6711 20 10C20 7.32891 18.9598 4.8177 17.0711 2.92891ZM10 18.8281C5.13215 18.8281 1.17188 14.8679 1.17188 10C1.17188 5.13215 5.13215 1.17188 10 1.17188C14.8679 1.17188 18.8281 5.13215 18.8281 10C18.8281 14.8679 14.8679 18.8281 10 18.8281Z" fill="#6ACE3C"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.8266 7.17764C14.5955 6.94078 14.2207 6.94078 13.9895 7.17768L8.7622 12.5353L6.01052 9.71503C5.77939 9.47813 5.40456 9.47813 5.17338 9.71503C4.94221 9.95193 4.94221 10.3361 5.17338 10.573L8.34361 13.8223C8.4592 13.9408 8.6107 14 8.76217 14C8.91363 14 9.06517 13.9407 9.18072 13.8223L14.8266 8.03565C15.0578 7.79875 15.0578 7.41458 14.8266 7.17764Z" fill="#6ACE3C"/></svg>';
        promoBaseText = 'Условия выполнены';
        promoBaseDescription = 'Вы выполнили условия:';
      } else {
        promoNotificationContent =
          '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="error-icon icon"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.0711 2.92891C15.1823 1.0402 12.6711 0 10 0C7.32887 0 4.81762 1.0402 2.92891 2.92891C1.04016 4.81766 0 7.32891 0 10C0 12.6711 1.04016 15.1823 2.92891 17.0711C4.81766 18.9598 7.32887 20 10 20C12.6711 20 15.1823 18.9598 17.0711 17.0711C18.9598 15.1823 20 12.6711 20 10C20 7.32891 18.9598 4.8177 17.0711 2.92891ZM10 18.8281C5.13215 18.8281 1.17188 14.8679 1.17188 10C1.17188 5.13215 5.13215 1.17188 10 1.17188C14.8679 1.17188 18.8281 5.13215 18.8281 10C18.8281 14.8679 14.8679 18.8281 10 18.8281ZM9.2951 5.46527C9.2951 5.07596 9.6107 4.76037 10 4.76037C10.3893 4.76037 10.7049 5.07596 10.7049 5.46527V12.1406C10.7049 12.5299 10.3893 12.8455 10 12.8455C9.6107 12.8455 9.2951 12.5299 9.2951 12.1406V5.46527ZM10 13.6526C9.53277 13.6526 9.15399 14.0313 9.15399 14.4986C9.15399 14.9658 9.53277 15.3446 10 15.3446C10.4673 15.3446 10.846 14.9658 10.846 14.4986C10.846 14.0313 10.4673 13.6526 10 13.6526Z" fill="#F02F2E"/></svg>';
        promoBaseText = 'Условия не выполнены';
        promoBaseDescription = 'Вы не выполнили условия:';
      }

      if (promo.expiresAt) {
        const date = new Date(promo.expiresAt);

        let day = date.getDate();
        let month = date.getMonth() + 1;

        if (date.getDate() < 10) {
          day = '0' + day;
        }

        if (date.getMonth() + 1 < 10) {
          month = '0' + month;
        }

        promoValidString = `<strong>Акция действует до ${day}.${month}.${date.getFullYear()}</strong>`;
      }

      return `<div class="promo-notification row ${
        promo.active ? 'valid' : 'error'
      }">
        ${promoNotificationContent}
        <div class="text very-small-text bold">
          Акция ${promo.name} <span>${promoBaseText}</span>
        </div>
        <div class="promo-description-wrapper row">
          <div class="promo-description very-small-text ${
            promo.data && promo.data.code && 'small-width'
          }">
            ${
              promo.description
                ? `${promoBaseDescription} ${promo.description}`
                : `${promoBaseDescription} ${promo.name}`
            }
          </div>
          ${
            promo.data && promo.data.code
              ? `<button type="button" class="cancel-promo small-text" data-code="${promo.data.code}">Отменить</button>`
              : ''
          }
          ${
            promo.expiresAt
              ? `<div class="valid-date placeholder-text">${promoValidString}</div>`
              : ''
          }
        </div>
      </div>`;
    });

    promoNotificationWrapper.innerHTML = items.join('');
  }
};

export default updatePromos;
